import React from 'react';
import { Link } from 'react-router-dom';
export const Header = () => {
  return <header className="bg-white shadow-sm sticky top-0 z-10" data-id="element-45">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-46">
        <Link to="/" className="font-bold text-xl text-[#0D9488]" data-id="element-47">
          ClearNail™
        </Link>
      </div>
    </header>;
};